export default __webpack_public_path__ + "static/media/feice.6aae1889.svg";